module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/025-anguilla-56fe5d22e1d32a65967ae1991e8f6fa0.svg";